import { hoverDynamic } from './hover';

export function word404() {
  if (typeof cardSetting === 'undefined' || !cardSetting.cards) {
    return;
  }
  const items = [];
  cardSetting.cards.forEach(function(card) {
    var link = card.permalink;
    if (Array.isArray(card.sentences) && card.sentences.length > 0) {
      card.sentences.forEach(function(sentence) {
        items.push({ text: sentence, permalink: link });
      });
    }
  });
  if (items.length > 0) {
    const outputEl = document.querySelector('.word-404');
    if(outputEl) { 
      const randomIndex = Math.floor(Math.random() * items.length);
      const item = items[randomIndex];
      const anchor = document.createElement('a');
      anchor.classList.add('hover-textcolor-primarysub');
      hoverDynamic(anchor);
      anchor.href = item.permalink;
      anchor.textContent = item.text;
      outputEl.appendChild(anchor);
    }
  }
}